import { Controller } from "@hotwired/stimulus"

// メール認証画面のインタラクションを管理するStimulusコントローラー
export default class extends Controller {
  static targets = ["codeInput", "submitButton", "resendButton", "timer", "countdown"]
  
  connect() {
    this.initializeResendTimer()
    this.validateCode()
  }

  // 認証コードのバリデーション
  validateCode() {
    const code = this.codeInputTarget.value.trim()
    const isValid = code.length > 0
    
    this.submitButtonTarget.disabled = !isValid
    
    if (isValid) {
      this.submitButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
    } else {
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
  }

  // 認証メール再送信
  async resendEmail(event) {
    event.preventDefault()
    
    // 再送信ボタンを無効化
    this.resendButtonTarget.disabled = true
    this.resendButtonTarget.textContent = "送信中..."
    
    try {
      const response = await fetch(this.resendButtonTarget.formAction, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
          "Accept": "text/vnd.turbo-stream.html"
        }
      })
      
      if (response.ok) {
        // Turbo Streamレスポンスを処理
        const responseText = await response.text()
        Turbo.renderStreamMessage(responseText)
        
        // 再送信タイマーを開始
        this.startResendTimer()
      } else {
        this.showError("認証メールの再送信に失敗しました。")
      }
    } catch (error) {
      console.error("Resend error:", error)
      this.showError("ネットワークエラーが発生しました。")
    } finally {
      this.resendButtonTarget.textContent = "認証メールを再送信"
      this.resendButtonTarget.disabled = false
    }
  }

  // 再送信タイマーの初期化
  initializeResendTimer() {
    // ページロード時に既に再送信制限がある場合のチェック
    const lastSentTime = localStorage.getItem('emailVerificationLastSent')
    if (lastSentTime) {
      const timeElapsed = Date.now() - parseInt(lastSentTime)
      const remainingTime = (5 * 60 * 1000) - timeElapsed // 5分間の制限
      
      if (remainingTime > 0) {
        this.startResendTimer(Math.ceil(remainingTime / 1000))
      }
    }
  }

  // 再送信タイマー開始
  startResendTimer(initialSeconds = 300) { // 5分 = 300秒
    if (!this.hasTimerTarget || !this.hasCountdownTarget) return
    
    // 現在時刻を保存
    localStorage.setItem('emailVerificationLastSent', Date.now().toString())
    
    let remainingSeconds = initialSeconds
    
    // タイマー表示を有効化
    this.timerTarget.classList.remove("hidden")
    this.resendButtonTarget.disabled = true
    this.resendButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    
    // カウントダウン更新
    const updateTimer = () => {
      const minutes = Math.floor(remainingSeconds / 60)
      const seconds = remainingSeconds % 60
      this.countdownTarget.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`
      
      if (remainingSeconds <= 0) {
        // タイマー終了
        this.timerTarget.classList.add("hidden")
        this.resendButtonTarget.disabled = false
        this.resendButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
        localStorage.removeItem('emailVerificationLastSent')
        clearInterval(this.resendInterval)
      } else {
        remainingSeconds--
      }
    }
    
    // 初回実行
    updateTimer()
    
    // 1秒間隔で更新
    this.resendInterval = setInterval(updateTimer, 1000)
  }

  // エラーメッセージ表示
  showError(message) {
    const flashContainer = document.getElementById("flash_messages")
    if (flashContainer) {
      flashContainer.innerHTML = `
        <div class="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <p class="text-sm font-medium text-red-800">${message}</p>
            </div>
          </div>
        </div>
      `
    }
  }

  // コントローラーが削除される際のクリーンアップ
  disconnect() {
    if (this.resendInterval) {
      clearInterval(this.resendInterval)
    }
  }
}
